import { useIonModal } from '@ionic/react'

import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { PortalUnitsFilterModal } from '@apps-common/components/modals/PortalUnitsFilterModal'
import { DEFAULT_ACTION_BUTTON_COLOR_CLASSES } from '@apps-common/config/colors'
import { commonIcons } from '@apps-common/config/icons'
import { MODAL_NO_BLUR } from '@apps-common/config/modal'
import { useFilterModalAnimation } from '@apps-common/hooks/useFilterModalAnimation'
import { IPortalUnitFilterDefaults } from '@apps-common/types/portal/unit'

interface IProps {
  defaults?: IPortalUnitFilterDefaults
}

export const PortalUnitsFilterButton: React.FC<IProps> = ({ defaults }) => {
  const animations = useFilterModalAnimation({ desktopCss: MODAL_NO_BLUR.cssClass })

  const [present, dismiss] = useIonModal(PortalUnitsFilterModal, {
    componentProps: {
      defaults
    },
    onDismiss: (data: string, role: string) => {
      dismiss(data, role)
    },
    enableBackdropDismiss: true
  })

  return (
    <ButtonRoundArrow
      classes={DEFAULT_ACTION_BUTTON_COLOR_CLASSES}
      iconClasses='text-on-brand'
      Icon={commonIcons.filter}
      callback={() =>
        present({
          cssClass: animations.css,
          ...animations
        })
      }
    />
  )
}
